import { createFilterOptions } from "@mui/material";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import en from "react-phone-number-input/locale/en";

// Single country code list for every phone/country picker in the app.
// callingCode has no "+" (e.g. "91"); label is what pickers display (e.g. "India (+91)").
export const COUNTRY_CODE_OPTIONS = getCountries()
  .map((iso) => {
    const name = en[iso] || iso;
    const callingCode = getCountryCallingCode(iso);
    return { iso, name, callingCode, label: `${name} (+${callingCode})` };
  })
  .sort((a, b) => a.name.localeCompare(b.name));

// Search by country name, ISO code or calling code ("india", "IN", "+91", "91")
export const filterCountryCodeOptions = createFilterOptions({
  stringify: (option) => `${option.name} ${option.iso} +${option.callingCode} ${option.callingCode}`,
});

// Several countries share a calling code (+1 US/Canada, +44 UK/Guernsey...); pick the main one
const CALLING_CODE_PREFERRED_COUNTRY = {
  1: "US",
  7: "RU",
  44: "GB",
  61: "AU",
  64: "NZ",
};

// "91" / "+91" -> "IN"; null when the calling code is unknown
export const getCountryForCallingCode = (callingCode) => {
  const code = String(callingCode || "").replace(/^\+/, "");
  if (!code) return null;
  return (
    CALLING_CODE_PREFERRED_COUNTRY[code] ||
    COUNTRY_CODE_OPTIONS.find((option) => option.callingCode === code)?.iso ||
    null
  );
};

// "971501234567" / "+971 501234567" -> { countryCode: "971", phone: "501234567" }
export const splitPhoneNumber = (fullNumber) => {
  const digits = String(fullNumber || "").replace(/\D/g, "");
  // Calling codes are prefix-free, so at most one matches
  const match = COUNTRY_CODE_OPTIONS.find((option) => digits.startsWith(option.callingCode));
  return match
    ? { countryCode: match.callingCode, phone: digits.slice(match.callingCode.length) }
    : { countryCode: "", phone: digits };
};
